import CommonDocument from '@/modules/common/hiring/models/MID/CommonDocument'

export default class ForeignHealthSaveDocumentInsuredRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: 23423-643hbf-74834hj. */
  quotationId!: string

  /** Lista de documentos a guardar. */
  document!: CommonDocument[]

  documentNumber!: string
  student?: string

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.document = data.document?.map((doc: any) => new CommonDocument(doc))
    this.documentNumber = data.documentNumber
    this.student = data.student
  }
}
